import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Apply.css';

const EnquiryForm = ({ closeModal }) => {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    course: '',
    
  });
  console.log(formData)

  const [isFormValid, setIsFormValid] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const isValid = Object.values(formData).every((value) => value.trim() !== '');
    setIsFormValid(isValid);
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://backendschool-hnoi.onrender.com/api/submit', formData);
      setSuccessMessage(response.data.message || 'Form submitted successfully!');
      setErrorMessage('');
      setFormData({ firstname: '', lastname: '', email: '', phone: '', course: '' });
      setTimeout(() => closeModal(), 2000);
    } catch (err) {
      setErrorMessage(err.response?.data?.message || 'Error submitting the form. Please try again.');
      setSuccessMessage('');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-btn" onClick={closeModal}>&times;</button>
        <h2 className="modal-title">Enquiry Form</h2>

        {successMessage && <p className="success-message">{successMessage}</p>}
        {errorMessage && <p className="error-message">{errorMessage}</p>}

        <form onSubmit={handleSubmit} className="form-container">
          <div className="form-group">
            <input
              type="text"
              name="firstname"
              value={formData.firstname}
              onChange={handleInputChange}
              placeholder="First Name"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              name="lastname"
              value={formData.lastname}
              onChange={handleInputChange}
              placeholder="Last Name"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Email Address"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="Phone Number"
              required
            />
          </div>
          <div className="form-group">
            <select
              name="course"
              value={formData.course}
              onChange={handleInputChange}
              required
            >
              <option value="">Choose Course</option>
              <option value="D.Pharmacy">D.Pharmacy</option>
              
            </select>
          </div>
          <button type="submit" className="submit-btn" disabled={!isFormValid}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnquiryForm;
